/**
 * Additional sites (Wave9 Hub register, 2026-10-01 — Mark's decisions).
 *
 * Some trusts run sites DfE/GIAS doesn't list (annexes, SEND units,
 * satellites, trust HQs). The Hub keeps a register of them and gives each a
 * PSEUDO-URN from a reserved range, its OWN HubSpot company (found by the
 * `w9_site_ref` property, never by `urn`), and returns them from the GIAS
 * search (`register: true`). This portal quotes them like any site, with three
 * rules:
 *
 *   1. A pseudo-URN never goes into a GIAS field — not the company `urn`, not
 *      the deal's `wave9_end_customer_urn`, not an asset's `gias_urn`.
 *   2. The deal carries `w9_site_ref` = the pseudo-URN instead.
 *   3. The deal's company is the SITE's company (the Hub created it); this
 *      portal never creates a company for a register site.
 *
 * Contract: wave9-portal/docs/additional-sites-contract-2026-09-30.md.
 * ⚠️ The range is pinned in the Hub (additionalSitesPure.mts) and the customer
 * portal (sitesPure.mts) — change all three or none.
 */

export const REGISTER_URN_MIN = 9_000_001
export const REGISTER_URN_MAX = 9_999_999
export const SITE_REF_PROPERTY = 'w9_site_ref'

export function isRegisterUrn(urn: unknown): boolean {
  if (urn == null || String(urn).trim() === '') return false
  const s = String(urn).trim()
  if (!/^\d+$/.test(s)) return false
  const n = Number(s)
  return n >= REGISTER_URN_MIN && n <= REGISTER_URN_MAX
}

/**
 * The deal's site identity for a URN: a GIAS URN goes to
 * `wave9_end_customer_urn` (as always); a register site's pseudo-URN goes to
 * `w9_site_ref` and the GIAS field is left empty. Exactly one is set.
 */
export function dealSiteIdentity(urn: string | null | undefined): { wave9_end_customer_urn: string | null; w9_site_ref: string | null } {
  const u = urn == null ? null : String(urn).trim() || null
  if (u && isRegisterUrn(u)) return { wave9_end_customer_urn: null, w9_site_ref: u }
  return { wave9_end_customer_urn: u, w9_site_ref: null }
}
